<script>
import { Router } from "svelte-navigator";
import Main from "./Main.svelte";
import * as config from './config.json';
</script>

<Router>
  <Main --primary={config.colors.primary} --secondary={config.colors.secondary} --text-primary={config.colors.textPrimary} --text-secondary={config.colors.textSecondary} />
</Router>

<style global>
@tailwind base;
@tailwind components;
@tailwind utilities;

@layer components {
  .center-all {
    @apply grid place-items-center;
  }

  .btn {
    @apply inline-flex px-4 py-2 rounded cursor-pointer text-lg font-extrabold uppercase select-none justify-center items-center;
    background-color: var(--secondary);
    color: var(--text-secondary) !important;
  }

  .btn.primary {
    background-color: var(--primary);
    color: var(--text-primary) !important;
  }

  .spinner, .spinner:after {
    border-radius: 50%;
    width: 24px;
    height: 24px;
  }

  .spinner {
    font-size: 3px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(255, 255, 255, 0.2);
    border-right: 1.1em solid rgba(255, 255, 255, 0.2);
    border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
    border-left: 1.1em solid #ffffff;
    transform: translateZ(0);
    animation: spinner-load 1.1s infinite linear;
  }

  @keyframes spinner-load {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  /* Phase these out */

  body {
    background-size: cover;
    background-attachment: fixed;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  }

  label {
    display: block;
  }

  /* input, select, textarea {
    font-size: inherit;
    border-radius: 6px;
    height: 42px;
    padding: 6px;

    border: none;
    outline: none;

    background: #FFFFFF;
    border: 2px solid black;
  }

  input:disabled {
    color: #ccc;
  } */

  .row {
    display: flex;
    flex-direction: row;
  }

  .row.vcenter {
    align-items: center;
  }

  .row.hcenter {
    justify-content: center;
  }

  .row.between {
    justify-content: space-between;
  }

  .row.nowrap {
    flex-wrap: nowrap;
  }

  .row.wrap {
    flex-wrap: wrap;
  }

  .row.end {
    justify-content: flex-end;
  }

  .col {
    display: flex;
    flex-direction: column;
  }

  .col.vcenter {
    justify-content: center;
  }

  .col.hcenter {
    align-items: center;
  }

  .col.between {
    align-items: space-between;
  }
  .col.start {
    align-items: flex-start;
  }

  .centercenter {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .section-header {
    text-transform: uppercase;
    margin-bottom: 16px;
    font-weight: 900;
    font-size: 20px;
  }

  /* Layout shared styles */

  .login-title {
    font-size: 32px;
    font-weight: 900;
    text-align: center;
    margin-bottom: 16px;
  }

  .login-subtitle {
    font-size: 20px;
    text-align: center;
    margin-bottom: 16px;
  }

  .slant {
    background-color: white;
    clip-path: polygon(0 0, 100% 0, 50% 100%, 0% 100%);
    width: 42px;
    height: 5rem;
  }

  .form-label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 4px;
  }

  .error-box {
    border-radius: 3px;
    padding: .75rem 1.25rem;
    border: 1px solid #eebdc5;
    background-color: #f3d0d6;
    color: #660919;
  }

  .success-box {
    border-radius: 3px;
    padding: .75rem 1.25rem;
    border: 1px solid #e9f8e8;
    background-color: #e9f8e8;
    color: #4b7348;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 123123123;
    background-color: rgba(0,0,0,.7);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .material-button {
    position: relative;
    padding: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
  }

  .shadow {
    box-shadow: 0 3px 5px #0008;
  }
}
</style>